
<div class="echr-page-wrapper">


    <ng-progress [color]="'#ffffff'"></ng-progress>
    <simple-notifications [options]="notificationOptions"></simple-notifications>

    <echr-header></echr-header>

    <nav class="navbar navbar-expand-md navbar-light bg-faded echr-page-menu" role="navigation">

        <!--<button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>-->


        <!--<div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="nav navbar-nav mr-auto mt-2 mt-lg-0">
                <li class="nav-item"><a class="nav-link ml-2 mr-2" routerLink="/"><i class="fas fa-home"></i></a></li>
            
            </ul>

            
        </div>-->
    </nav>

    <div class="echr-page-content" style="display: inline-flex;">
        <router-outlet></router-outlet>
    </div>

    <echr-footer></echr-footer>


</div>









